export const topicListSortType = {
  publishedAt: "published_at",
  lastmod: "lastmod",
  session: "session",
} as const;
